import { useState } from 'react';
import { useMount, useUnmount } from 'react-use';

// TODO: when https://github.com/streamich/react-use/pull/1171 is merged
// we can remove this file and switch the react-use version

const createGlobalState = (initialState) => {
  const store = {
    state: initialState,
    setState(state) {
      store.state = state;
      store.setters.forEach((setter) => setter(store.state));
    },
    setters: [],
  };

  return () => {
    const [globalState, stateSetter] = useState(store.state);

    useMount(() => {
      store.setters.push(stateSetter);
    });

    useUnmount(() => {
      store.setters = store.setters.filter((setter) => setter !== stateSetter);
    });

    return [globalState, store.setState];
  };
};

export default createGlobalState;
